const path = "/remocao/pre-inscricao";

export default {
  validarServidor: (cpf, ano) => `${path}/validar-servidor/${cpf}/${ano}`,
  solicitarInscricao: `${path}/solicitar-inscricao`,
  finalizarInscricao: `${path}/finalizar-inscricao`,
  listarInscricao: `${path}/listar-inscricao`,
};
